import { render, staticRenderFns } from "./Materias.vue?vue&type=template&id=7d30501a&"
import script from "./Materias.vue?vue&type=script&lang=js&"
export * from "./Materias.vue?vue&type=script&lang=js&"
import style0 from "./Materias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports